import httpRequest from "../../ajax";
import {
  CHANGE_PASSWORD,
  ERROR,
  GET_NOTIFICATIONS,
  GET_NOTIFICATION_SETTINGS,
  UPDATE_NOTIFICATION_SETTINGS,
} from "../actionTypes";
import { logoutAction } from "./authActions";

export const getNotificationSettings = (dispatch) =>
  httpRequest("get", "/settings/profile/notification")
    .then(({ data: { data } }) => {
      const action = { type: GET_NOTIFICATION_SETTINGS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getNotifications = (dispatch) =>
  httpRequest("get", "/settings/profile/notification/log/1/100")
    .then(({ data: { data } }) => {
      const notifications = data.notifications || [];
      const unreadCount = notifications.filter(
        (n) => n.is_read === 0 || n.is_read === "0"
      ).length;
      dispatch({ type: GET_NOTIFICATIONS, payload: notifications });
      dispatch({ type: "SET_UNREAD_NOTIFICATION_COUNT", payload: unreadCount });
      return { notifications, unreadCount };
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const getUnreadNotificationCount = (dispatch) =>
  getNotifications(dispatch).then((result) => {
    if (result?.type === ERROR) {
      return result;
    }
    return {
      type: "SET_UNREAD_NOTIFICATION_COUNT",
      payload: result.unreadCount,
    };
  });

export const markNotificationAsRead = (dispatch, notificationId) =>
  httpRequest("post", `/settings/profile/notification/${notificationId}/mark-as-read`)
    .then(({ data }) => {
      getUnreadNotificationCount(dispatch);
      return data;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const markAllNotificationsAsRead = (dispatch) =>
  httpRequest("post", "/settings/profile/notification/mark-all-as-read")
    .then(({ data }) => {
      getNotifications(dispatch);
      getUnreadNotificationCount(dispatch);
      return data;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const updateNotificationSettings = (dispatch, data) =>
  httpRequest("post", "/settings/profile/notification/update", data)
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_NOTIFICATION_SETTINGS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

// Sprint 3: notification level preference (PRD §6.5: all | important | none)
export const updateNotificationLevel = (dispatch, level) =>
  httpRequest("post", "/settings/profile/notification/level", {
    notification_level: level,
  })
    .then(({ data: { data } }) => {
      const action = { type: UPDATE_NOTIFICATION_SETTINGS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const changePassword = (dispatch, data) =>
  httpRequest("post", "/user/changePassword", data)
    .then(({ data: { data } }) => {
      const action = { type: CHANGE_PASSWORD, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));

export const deleteAccount = (data) =>
  httpRequest("post", "/settings/profile/deleteAccount", data)
    .then(() => {
      return logoutAction();
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
